export default __webpack_public_path__ + "static/media/Pattern2.89af3a6e.png";